import { Icon } from '../icons/Icon.js';
import type { IconName } from '../icons/registry.js';

export interface TabItem<T extends string> {
  id: T;
  label: string;
  icon?: IconName;
}

export interface TabsProps<T extends string> {
  items: TabItem<T>[];
  value: T;
  onChange: (id: T) => void;
  ariaLabel: string;
}

export function Tabs<T extends string>({ items, value, onChange, ariaLabel }: TabsProps<T>) {
  return (
    <div className="tb-tabs" role="tablist" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={item.id === value}
          className="tb-tab"
          onClick={() => onChange(item.id)}
        >
          {item.icon ? <Icon name={item.icon} size={16} /> : null}
          {item.label}
        </button>
      ))}
    </div>
  );
}
